@if(itemDetailsQuery.isLoading()) {
<ngx-skeleton-loader appearance="line" [count]="10"></ngx-skeleton-loader>
} @else {
@if(itemDetailsQuery.data()) {
<div class="flex flex-row justify-end items-center">
    <div class="basis-auto flex-grow-0 flex-shrink-0">
        <app-item-public-link [item]="itemDetailsQuery.data().item"></app-item-public-link>
    </div>
</div>
<div class="flex flex-row justify-start items-center">
    <div class="basis-full flex-shrink">
        <prices-display [prices]="itemDetailsQuery.data().product.prices"></prices-display>
    </div>
</div>
@for (type of orderedSections(); track type) {
<div class="flex flex-col justify-start items-stretch gap-y-4">
    <app-item-summary-section [type]="type" [details]="itemDetailsQuery.data()"
        (selectTab)="selectTab.emit(type)"></app-item-summary-section>
</div>
}
} @else {
<p>Failed to get item details</p>
}
}